module.exports = __webpack_public_path__ + "img/p1.61ed76f1.svg";